import { render, staticRenderFns } from "./Omise.vue?vue&type=template&id=761b63cc&"
import script from "./Omise.vue?vue&type=script&lang=js&"
export * from "./Omise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports